function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import Select from "react-select";
import CurrencyInput from "../../../../helperComponents/CurrencyInput/CurrencyInput";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatValue, getSeparatorByCurrency, formatDecimal } from "../../../../utils/currency";
import { listTipoDePago, listNumberOfCuotes, TipoDePagoTypes } from "../../../../utils/data";
import { getCurrencyByString } from "../../../../utils/currency";
import { transformDataToOption } from "../../../../utils/SelectUtils";
import WireTransferInfo from "./paymentMethods/WireTransferInfo";
import CreditCardInfo from "./paymentMethods/CreditCardInfo"; // Constante para los factores de cuota

var INSTALLMENT_FACTORS = {
  1: 1.0000,
  2: 0.5016,
  3: 0.3355,
  4: 0.2524,
  5: 0.2026,
  6: 0.1694,
  7: 0.1456,
  8: 0.1279,
  9: 0.1140,
  10: 0.1029,
  11: 0.0930,
  12: 0.0860,
  13: 0.0795,
  14: 0.0740,
  15: 0.0695,
  16: 0.0655,
  17: 0.0620,
  18: 0.0590
};

var PaymentMethod = function PaymentMethod(props) {
  var poliza = props.poliza,
      _onChange = props.onChange,
      companies = props.companies,
      banksOption = props.banksOption,
      token = props.token;
  var tipoDePagoOptions = transformDataToOption(listTipoDePago);
  var numberOfCuotesOptions = transformDataToOption(listNumberOfCuotes);
  var selectedTipoDePago = poliza.tipo_de_pago ? tipoDePagoOptions.find(function (option) {
    return option.value === poliza.tipo_de_pago;
  }) : null;
  var selectedNumberOfCuotes = poliza.number_of_cuotes && {
    label: "".concat(poliza.number_of_cuotes),
    value: "".concat(poliza.number_of_cuotes)
  };
  var currency = getCurrencyByString(poliza.currency);
  var currentCompany = companies.find(function (company) {
    return company.id === poliza.company_id;
  });
  var currencyFormat = getSeparatorByCurrency(poliza.currency); // Función para calcular el valor de la cuota

  var calculateInstallmentValue = function calculateInstallmentValue(numberOfInstallments, totalPremium) {
    var factor = INSTALLMENT_FACTORS[numberOfInstallments] || 0;
    return totalPremium * factor;
  };

  var onChangeTotales = function onChangeTotales(newItem) {
    var new_data = _objectSpread(_objectSpread({}, poliza.broker_information), newItem);

    var net_bonus = new_data.affects_net_bonus + new_data.exempt_net_bonus;
    var iva = new_data.affects_net_bonus * 0.19;
    var total_bonus = new_data.affects_net_bonus + new_data.exempt_net_bonus + new_data.affects_net_bonus * 0.19;

    var broker_information = _objectSpread(_objectSpread({}, new_data), {}, {
      net_bonus: formatDecimal(net_bonus, currencyFormat.decimalLimit),
      iva: formatDecimal(iva, currencyFormat.decimalLimit),
      total_bonus: formatDecimal(total_bonus, currencyFormat.decimalLimit)
    }); // Actualizar el valor de la cuota si hay número de cuotas seleccionado y no está en modo manual


    if (poliza.number_of_cuotes && !isManualInstallmentMode) {
      var installmentValue = calculateInstallmentValue(poliza.number_of_cuotes, total_bonus);

      _onChange(_objectSpread(_objectSpread({}, poliza), {}, {
        broker_information: broker_information,
        first_cuote: formatDecimal(installmentValue, currencyFormat.decimalLimit)
      }));
    } else {
      _onChange(_objectSpread(_objectSpread({}, poliza), {}, {
        broker_information: broker_information
      }));
    }
  };

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isManualInstallmentMode = _React$useState2[0],
      setIsManualInstallmentMode = _React$useState2[1];

  var handleInstallmentModeChange = function handleInstallmentModeChange(checked) {
    setIsManualInstallmentMode(checked);

    if (!checked && poliza.number_of_cuotes) {
      var installmentValue = calculateInstallmentValue(poliza.number_of_cuotes, poliza.broker_information.total_bonus || 0);
      _onChange && _onChange({
        first_cuote: formatDecimal(installmentValue, currencyFormat.decimalLimit)
      });
    }
  };

  var handleInstallmentValueChange = function handleInstallmentValueChange(value) {
    _onChange && _onChange({
      first_cuote: formatDecimal(value, currencyFormat.decimalLimit)
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card cntTotales"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-footer"
  }, /*#__PURE__*/React.createElement("strong", null, "Totales")), /*#__PURE__*/React.createElement("div", {
    className: "card-body row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Prima Neta Afecta"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    defaultValue: poliza.broker_information.affects_net_bonus,
    currency: currencyFormat.currency,
    onValueChange: function onValueChange(value) {
      return onChangeTotales({
        affects_net_bonus: formatValue(value, currencyFormat.decimalLimit)
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Prima Neta Exenta"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    defaultValue: poliza.broker_information.exempt_net_bonus,
    currency: currencyFormat.currency,
    onValueChange: function onValueChange(value) {
      return onChangeTotales({
        exempt_net_bonus: formatValue(value, currencyFormat.decimalLimit)
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Prima Neta"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    currency: currencyFormat.currency,
    value: poliza.broker_information.net_bonus,
    disabled: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "IVA"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    currency: currencyFormat.currency,
    value: poliza.broker_information.iva,
    disabled: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Prima Total"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    currency: currencyFormat.currency,
    value: poliza.broker_information.total_bonus,
    disabled: true
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-center mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, poliza.tipo_de_pago && poliza.tipo_de_pago == TipoDePagoTypes.PAC && /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-footer"
  }, /*#__PURE__*/React.createElement("strong", null, "Informaci\xF3n de Transferencia")), /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement(WireTransferInfo, {
    poliza: poliza,
    token: token,
    banksOption: banksOption,
    onChange: function onChange(payment_information) {
      _onChange && _onChange({
        payment_information: payment_information
      });
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-center mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, poliza.tipo_de_pago && poliza.tipo_de_pago == TipoDePagoTypes.PAT && /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-footer"
  }, /*#__PURE__*/React.createElement("strong", null, "Informaci\xF3n de Tarjeta de Cr\xE9dito")), /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement(CreditCardInfo, {
    poliza: poliza,
    token: token,
    banksOption: banksOption,
    onChange: function onChange(payment_information) {
      _onChange && _onChange({
        payment_information: payment_information
      });
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-center mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-footer"
  }, /*#__PURE__*/React.createElement("strong", null, "Forma de Pago")), /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Forma de pago"), /*#__PURE__*/React.createElement(Select, {
    options: tipoDePagoOptions,
    value: selectedTipoDePago,
    placeholder: "Tipo de pago...",
    onChange: function onChange(item) {
      return _onChange && _onChange({
        tipo_de_pago: item.value
      });
    }
  })), poliza.tipo_de_pago && poliza.tipo_de_pago !== TipoDePagoTypes.CONTADO && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "N\xFAmero cuotas"), /*#__PURE__*/React.createElement(Select, {
    isClearable: true,
    value: selectedNumberOfCuotes,
    onChange: function onChange(item) {
      if (item) {
        var numberOfInstallments = parseInt(item.value);
        var factor = INSTALLMENT_FACTORS[numberOfInstallments]; // Solo calcular automáticamente si no está en modo manual

        if (!isManualInstallmentMode) {
          var installmentValue = calculateInstallmentValue(numberOfInstallments, poliza.broker_information.total_bonus || 0);
          _onChange && _onChange({
            number_of_cuotes: numberOfInstallments,
            first_cuote: formatDecimal(installmentValue, currencyFormat.decimalLimit),
            installment_factor: factor
          });
        } else {
          // En modo manual, solo actualizar el número de cuotas y factor
          _onChange && _onChange({
            number_of_cuotes: numberOfInstallments,
            installment_factor: factor
          });
        }
      } else {
        _onChange && _onChange({
          number_of_cuotes: null,
          first_cuote: 0,
          installment_factor: null
        });
      }
    },
    options: numberOfCuotesOptions
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Factor Cuota"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    value: poliza.installment_factor || (poliza.number_of_cuotes ? INSTALLMENT_FACTORS[poliza.number_of_cuotes] : 0),
    currency: currencyFormat.currency,
    onValueChange: function onValueChange(value) {
      var newFactor = formatValue(value, 4);

      if (!isNaN(newFactor)) {
        // Solo recalcular automáticamente si NO está en modo manual
        if (!isManualInstallmentMode) {
          var installmentValue = poliza.broker_information.total_bonus * newFactor;
          _onChange && _onChange({
            installment_factor: newFactor,
            first_cuote: formatDecimal(installmentValue, currencyFormat.decimalLimit)
          });
        } else {
          // En modo manual, solo actualizar el factor sin recalcular el valor
          _onChange && _onChange({
            installment_factor: newFactor
          });
        }
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Valor cuotas"), isManualInstallmentMode ? /*#__PURE__*/React.createElement("div", {
    className: "input-group"
  }, /*#__PURE__*/React.createElement("span", {
    className: "input-group-addon"
  }, "UF"), /*#__PURE__*/React.createElement("input", {
    type: "number",
    className: "form-control",
    value: poliza.first_cuote || '',
    step: "0.001",
    min: "0",
    placeholder: "0.000",
    onChange: function onChange(e) {
      var value = parseFloat(e.target.value) || 0;
      _onChange && _onChange({
        first_cuote: value
      });
    }
  })) : /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    value: poliza.first_cuote || 0,
    currency: currencyFormat.currency,
    disabled: true,
    onValueChange: function onValueChange(value) {
      var numericValue = formatValue(value, currencyFormat.decimalLimit);
      _onChange && _onChange({
        first_cuote: numericValue
      });
    }
  }))), poliza.tipo_de_pago && poliza.tipo_de_pago === TipoDePagoTypes.CONTADO && /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Pagado previamente"), /*#__PURE__*/React.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: poliza.is_prepaid,
    onChange: function onChange() {
      return _onChange && _onChange({
        is_prepaid: !poliza.is_prepaid
      });
    }
  }), "Se ha pagado previamente ?"))), poliza.tipo_de_pago && poliza.tipo_de_pago !== TipoDePagoTypes.CONTADO && /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Fecha primer Vencimiento"), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd-MM-yyyy",
    selected: poliza.first_expiration_date,
    onChange: function onChange(item) {
      _onChange && _onChange({
        first_expiration_date: item
      });
    }
  })), poliza.tipo_de_pago && (poliza.tipo_de_pago === TipoDePagoTypes.CONTADO || poliza.tipo_de_pago === TipoDePagoTypes.AVISO_DE_VENCIMIENTO) && currentCompany && /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Pago Transferencia"), /*#__PURE__*/React.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: poliza.show_transfer_payment,
    onChange: function onChange() {
      return _onChange && _onChange({
        show_transfer_payment: !poliza.show_transfer_payment
      });
    }
  }), "Mostrar pago por transferencia"))), poliza.tipo_de_pago && poliza.tipo_de_pago !== TipoDePagoTypes.CONTADO && /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: isManualInstallmentMode,
    onChange: function onChange(e) {
      return handleInstallmentModeChange(e.target.checked);
    }
  }), "Ingresar valor cuotas manualmente")))))))));
};

export default PaymentMethod;